import { swatchHover } from './mous-product-form.js';

let quickViewModal = document.querySelector(".quickview-modal");
let quickViewModalInner = quickViewModal.querySelector(".inner");

if (quickViewModal) {
    document.body.addEventListener("click", (e) => {
        const target = e.target;

        if (target.closest("[open-quickview-modal]")) {
            quickViewModal.classList.add("modal-open");
            onModalOpen(e);
            document.body.classList.add("locked");
        } else if (
            target.closest("[close-quickview-modal]") ||
            target.classList.contains("compare-modal-outer")
        ) {
            quickViewModal.classList.remove("modal-open");
            removeInjectedContent();
            document.body.classList.remove("locked");
        }
    });

    window.addEventListener('item_added', () => {
        quickViewModal.classList.remove("modal-open");
        removeInjectedContent();
    });

    const onModalOpen = async (e) => {
        const quickViewButton = e.target.closest("[open-quickview-modal]");
        if (quickViewButton) {
            const handle = quickViewButton.getAttribute("data-product-handle");
            const sectionName = "mous-main-product";
            let selectedDevice = getSelectedDevice();
            const variantId = e.target.closest("[product-card]").getAttribute('data-variant-id');

            if (handle) {
                const response = await fetch(
                    `${window.Shopify.routes.root}products/${handle}?sections=${sectionName}&notifyMe=no&bundles=no${selectedDevice ? '&variant=' + variantId : ''}`
                );
                if (response.ok) {
                    const data = await response.json();
                    const html = data[sectionName];
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    if (quickViewModalInner && doc) {
                        updateSwatches(doc);
                        updateSecondVariantOptions(doc);
                        updateATC(doc);
                        updateRatingBars(doc);
                        updateDeviceSelected(doc, selectedDevice);
                        updateProductDecription(doc);

                        let optionValueElement = doc.body.querySelector('#mainProductSelect');

                        if (optionValueElement) {
                            // To handle differences between select and input elements
                            if (optionValueElement.tagName === 'SELECT') {
                                const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
                                optionValueElement = selectedOption;
                            }
                            const newVariantId = optionValueElement.dataset.variantId;
                            updateShopNowButton(doc, newVariantId);
                        }
                        
                        quickViewModalInner.innerHTML = doc.body.innerHTML;

                        // Append the sticky ATC to the quickViewModal HTML
                        appendStickyATCButton(doc.body);

                        initializeSwipers();
                        updateDeviceSelected(quickViewModalInner, selectedDevice);
                        swatchHover(quickViewModalInner);

                        // commenting out as function is undefined, yotpo no longer used
                        // yotpoWidgetsContainer.initWidgets();

                        //focus on select a device if device not selected
                        quickViewModalInner.querySelectorAll('[data-focus-select-a-device]').forEach(element => {
                            if (element) {
                                element.addEventListener('click', () => {
                                    window.dispatchEvent(new CustomEvent('quickview-select-a-device'));
                                });
                            }
                        });

                        // const productPageButton = doc.createElement("a");
                        // const productOptionsFormWrapper = quickViewModalInner.querySelector(
                        //     ".product-options-form-wrapper"
                        // );
                        // if (productOptionsFormWrapper) {
                        //     productPageButton.href = productOptionsFormWrapper.getAttribute(
                        //         "data-product-url"
                        //     );
                        // }
                        // productPageButton.classList.add("button-5");
                        // productPageButton.innerHTML = "View product & bundles";
                        // const productSubmitWrapper = quickViewModalInner.querySelector(
                        //     ".product-submit-wrapper"
                        // );
                        // if (productSubmitWrapper) {
                        //     productSubmitWrapper.insertAdjacentElement(
                        //         "beforebegin",
                        //         productPageButton
                        //     );
                        // }
                    }
                }
            }
        }

        const modalOpenEvent = new CustomEvent('quickview-modal-opened');
        window.dispatchEvent(modalOpenEvent);
    };

    const updateSwatches = (doc) => {

        // Get the 2nd variant options (camera control = button/no button)
        const secondVariantOptions = doc.querySelectorAll(".second-variant-options__option");
        // default to first option index
        let indexOfActiveSecondVariantOption = 0;
        // find the active option
        secondVariantOptions.forEach((option,index) => {
            if (option.classList.contains("active")) {
                // assign index of active option
                indexOfActiveSecondVariantOption = index;
            }
        });


        const materialSwatches = doc.querySelectorAll(".color-circle");
                materialSwatches.forEach((swatch) => {
            if (swatch) {
                const img = swatch.querySelector("img");
                const id = swatch.getAttribute("data-variant-id");
                const material = swatch.getAttribute("data-material");
                const swatchHandle = swatch.href.split("/").pop();

                // get all data-href-* attributes 
                const hrefAttributes = Object.keys(swatch.dataset).filter(key => key.startsWith("href-"));
                // get values of these attributes and builf object with key and value
                const availablehrefs = hrefAttributes.map(key => ({
                    key: key,
                    value: swatch.dataset[key]
                }));
                let url = ''
                if(availablehrefs.length > 0) {
                    // if availablehrefs is not empty, assign the url to the value of the active indexed variant option
                    url = availablehrefs[indexOfActiveSecondVariantOption].value.split("/products/").pop();
                } else {
                    // if availablehrefs is empty, assign the url to the swatch handle which is the default
                    url = swatchHandle;
                }

                const button = document.createElement("button");
                button.type = "button";
                button.classList.add("color-circle");
                button.innerHTML = img.outerHTML;
                button.setAttribute("data-variant-id", id);
                button.setAttribute("data-product-url", url);
                button.setAttribute("data-material", material);

                if (!url.includes("?variant=")) {
                    button.setAttribute("data-focus-select-a-device", "");
                }



                // Get all data-available-* attributes
                const availableAttributes = Object.keys(swatch.dataset).filter(key => key.startsWith("available-"));
                // Get values of these attributes
                const availableValues = availableAttributes.map(key => ({
                    key: key,
                    value: swatch.dataset[key]
                }));

                if(availableValues.length > 0) {
                    // if availableValues is not empty, check if the value of the active indexed variant option is false
                    if (availableValues[indexOfActiveSecondVariantOption].value === 'false') {
                        // if it is false, add the disabled class to the button
                        button.classList.add("disabled");
                    }
                }

                if (swatch.classList.contains("selected-swatch")) {
                    button.classList.add("selected-swatch");
                }
                if (swatch.classList.contains("is-unavailable")) {
                    button.classList.add("is-unavailable");
                }

                swatch.replaceWith(button);
            }
        });
    };

    const updateSecondVariantOptions = (doc) => {
        const secondVariantOptions = doc.querySelectorAll(".second-variant-options__option");
        secondVariantOptions.forEach((option) => {
            if (option) {
                const id = option.getAttribute("data-variant-id");
                const secondVariantOptionHandle = option.href.split("/").pop();

                const button = document.createElement("button");
                button.type = "button";
                button.classList.add("second-variant-options__option");
                button.innerHTML = option.innerHTML;
                button.setAttribute("data-variant-id", id);
                button.setAttribute("data-product-url", secondVariantOptionHandle);
                if (option.classList.contains("active")) {
                    button.classList.add("active");
                }
                if (option.classList.contains("featured-image")) {
                    button.classList.add("featured-image");
                }

                option.replaceWith(button);
            }
        });
    };

    const updateShopNowButton = (doc, variantId) => {
        const shopNowButton = doc.querySelector(".view-product");
        if (shopNowButton) {
            const url = new URL(shopNowButton.href);
            if (variantId) {
                url.searchParams.set('variant', variantId);
            }
            shopNowButton.href = url.href;
        }
    };

    const removeInjectedContent = () => {
        const productElement = document.querySelector(".quickview-modal");
        const injectedGallery = productElement.querySelector(".gallery-container");
        const injectedWishlist = productElement.querySelector(".button-wishlist");
        const injectedContent = productElement.querySelector(
            "#productSectionWrapper"
        );

        if (injectedContent) injectedContent.remove();
        if (injectedGallery) injectedGallery.remove();
        if (injectedWishlist) injectedWishlist.remove();

        const modalContent = document.querySelector(
            ".quickview-modal .compare-modal .modal-content"
        );
        const quickviewProductForm = document.createElement("div");
        quickviewProductForm.classList.add("quickview-product-form");
        modalContent.appendChild(quickviewProductForm);

        // Remove the existing sticky ATC button if it exists
        const existingStickyATCButton = quickViewModal?.querySelector('.modal-sticky-add-to-cart');
        if (existingStickyATCButton) {
            existingStickyATCButton.remove();
        }
    };

    const fetchProductWithVariant = async (productUrl, sectionName, variantId) => {
        const response = await fetch(
            `${window.Shopify.routes.root}products/${productUrl}&sections=${sectionName}&bundles=no&notifyMe=no`
        );
        if (response.ok) {
            const data = await response.json();
            const html = data[sectionName];
            const doc = new DOMParser().parseFromString(html, "text/html");

            if (quickViewModalInner && doc) {
                updateSwatches(doc);
                updateSecondVariantOptions(doc);
                updateShopNowButton(doc, variantId);
                updateRatingBars(doc);
                updateATC(doc);
                updateProductDecription(doc);
                setTimeout(() => {
                    swatchHover(quickViewModalInner);
                  }, 100);
                quickViewModalInner.innerHTML = doc.body.innerHTML;

                // Remove the existing sticky ATC button if it exists
                const existingStickyATCButton = quickViewModal?.querySelector('.modal-sticky-add-to-cart');
                if (existingStickyATCButton) {
                    existingStickyATCButton.remove();
                }

                // Append the sticky ATC to the quickViewModal HTML
                appendStickyATCButton(doc.body);

                initializeSwipers();
                // commenting out as function is undefined, yotpo no longer used
                // yotpoWidgetsContainer.initWidgets();
            }
            
            const modalOpenEvent = new CustomEvent('quickview-modal-opened');
            window.dispatchEvent(modalOpenEvent);
        } else {
            console.error("Error fetching the product with variant:", productUrl);
        }
    };

    const initializeSwipers = () => {
        document.querySelectorAll('.modal .gallery-container').forEach(galleryContainer => {
            const thumbSwiper = new window.swiper(galleryContainer.querySelector(".thumb-swiper"), {
                spaceBetween: 15,
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: galleryContainer.querySelector('.thumb-product-gallery-navigation.swiper-button-next'),
                    prevEl: galleryContainer.querySelector('.thumb-product-gallery-navigation.swiper-button-prev'),
                },
            });
        
            const mainSwiper = new window.swiper(galleryContainer.querySelector(".main-swiper"), {
                navigation: {
                    nextEl: galleryContainer.querySelector('.main-product-gallery-navigation.swiper-button-next'),
                    prevEl: galleryContainer.querySelector('.main-product-gallery-navigation.swiper-button-prev'),
                },
                spaceBetween: 0,
                thumbs: {
                    swiper: thumbSwiper,
                },
                on: {
                    init: () =>{
                        var main_swiper_slide = galleryContainer.querySelector('.main-swiper-slide');
                        var thumb_swiper_slide = galleryContainer.querySelector('.swiper-slide.thumb');
                        var thumb_swiper = galleryContainer.querySelector('.thumb-swiper');
                
                        var main_swiper_width = main_swiper_slide.offsetWidth;
                        var thumb_swiper_width = thumb_swiper_slide.offsetWidth;
                
                        main_swiper_slide.style.height = main_swiper_width + 'px';
                        galleryContainer.style.opacity = 1;
                
                        window.addEventListener('resize', () =>{
                            var main_swiper_slide = galleryContainer.querySelector('.main-swiper');
                            var thumb_swiper_slide = galleryContainer.querySelector('.swiper-slide.thumb');
                            var thumb_swiper = galleryContainer.querySelector('.thumb-swiper');
            
                            var main_swiper_width = main_swiper_slide.offsetWidth;
                            var thumb_swiper_width = thumb_swiper_slide.offsetWidth;
            
                            main_swiper_slide.style.height = main_swiper_width + 'px';
            
                            if (window.innerWidth > 991.98) {
                                thumb_swiper.style.height = main_swiper_width + 'px';
                            } else {
                                thumb_swiper.style.height = thumb_swiper_width + 'px';
                            }
                        });
                    }
                },
            });
        });
    };

    function updateATC(doc) {
        const chooseDevice = doc.querySelector("#choose-device");
        const atcButton = doc.querySelector('[add-to-cart]');
    
        if (!chooseDevice) {
            //console.error("#choose-device element not found.");
            return;
        }
    
        if (!atcButton) {
            //console.error("Add to Cart button not found.");
            return;
        }
    
        const selectElement = chooseDevice.querySelector("select");
    
        if (!selectElement) {
            const price = atcButton.getAttribute('data-price');
            const compareAtPrice = atcButton.getAttribute('data-compare-at-price');

            if (price && compareAtPrice) {
                // Convert the prices to money format
                const formattedPrice = (parseInt(price) / 100).toFixed(2);
                const formattedCompareAtPrice = (parseInt(compareAtPrice) / 100).toFixed(2);

                // Update the button text with the prices
                atcButton.innerHTML = `Add to cart - <s>£${formattedCompareAtPrice}</s> £${formattedPrice}`;
            } else {
                console.error('Price or Compare-at-Price data attributes missing.');
            }
            atcButton.type = "submit";
        }
    }

    const appendStickyATCButton = (doc) => {
        const stickyATCButton = doc.querySelector('.sticky-add-to-cart');
        if (stickyATCButton) {
            const clonedButton = stickyATCButton.cloneNode(true);
            quickViewModal.prepend(clonedButton);
            clonedButton.classList.add('modal-sticky-add-to-cart');
        }
    };

    quickViewModalInner.addEventListener("click", (e) => {
        const target = e.target.closest(".color-circle") || e.target.closest(".second-variant-options__option");
        if (target && target.getAttribute("data-variant-id")) {
            const productUrl = target.getAttribute("data-product-url");
            const sectionName = "mous-main-product";
            if (productUrl.includes("?variant=")) {
                fetchProductWithVariant(productUrl, sectionName, target.getAttribute("data-variant-id"));
            }
        }
    });

    const updateRatingBars = (doc) => {
        const targets = doc.querySelectorAll(".rating-bar");
        if (targets) {
            targets.forEach(bar => {
                const ratingValue = bar.getAttribute('data-rating');
                // no setTimeout needed otherwise we render the bar at 0% and the time out occurs after so we don't see the animation
                bar.style.setProperty('--rating-width', `${ratingValue}%`);
            });
        }
    }

    const updateDeviceSelected = async (doc, selectedDevice) => {
        const selectElement = doc.querySelector("#mainProductSelect"); 

        if (selectElement) {
            // get all selectElement options
            const selectElementOptions = selectElement.querySelectorAll('option');
            // get all selectElement options values
            const selectElementOptionsValues = Array.from(selectElementOptions).map(option => option.value);
            // check if selectedDevice is in selectElementOptionsValues
            const isDeviceAvailable = selectElementOptionsValues.includes(selectedDevice);
            // set the selectedDevice only if it is available
            if (isDeviceAvailable) {
                if (selectedDevice !== '' || selectedDevice !== null) {
                    selectElement.value = selectedDevice;
                }
            }
        }
    }

    const getSelectedDevice = () => {
        const LOCAL_STORAGE_CLIENT_NAME = window.Shopify.shop.replace(/.myshopify.com/g,'');
        const LOCAL_STORAGE_KEY = LOCAL_STORAGE_CLIENT_NAME + '__selected_device';
        return localStorage.getItem( LOCAL_STORAGE_KEY );
    }


    const updateProductDecription = (doc) => {
        const productDescription = doc.querySelector('.product-description');
        if (productDescription && productDescription.innerText.length >= 200) {
            let productDescriptionTruncated = productDescription.innerText.slice(0, 200).trim() + '…';
            productDescription.innerText = productDescriptionTruncated;
            }
    }


    window.addEventListener('productFormRendered', (event) => {
        const variantId = event.detail;
        quickViewModal = document.querySelector('.quickview-modal');
        quickViewModalInner = quickViewModal.querySelector('.inner');
        updateSwatches(quickViewModal);
        updateSecondVariantOptions(quickViewModal);
        updateATC(quickViewModal);
        updateShopNowButton(quickViewModal, variantId);
        swatchHover(quickViewModalInner);
        initializeSwipers();
        updateRatingBars(quickViewModal);

        // Remove the existing sticky ATC button if it exists
        const existingStickyATCButton = quickViewModal?.querySelector('.modal-sticky-add-to-cart');
        if (existingStickyATCButton) {
            existingStickyATCButton.remove();
        }

        // Append the sticky ATC to the quickViewModal HTML
        appendStickyATCButton(quickViewModalInner);

        // commenting out as function is undefined, yotpo no longer used
        // yotpoWidgetsContainer.initWidgets();
    });
}
